import { useState, createContext, useEffect } from 'react';

const SearchContext = createContext();

const SearchProvider = ({ children, origin, categorySlug, seoDescription }) => {
  const [parentSection, setParentSection] = useState(origin ?? 'search');
  const [category, setCategory] = useState(categorySlug ?? '');

  return (
    <SearchContext.Provider value={{ parentSection, setParentSection, category, setCategory, seoDescription}}>
      <div id={`list-name-${parentSection}`}>
        {children}
      </div>
    </SearchContext.Provider>
  );
}

export { SearchContext, SearchProvider };